import React, { useEffect, useState, useMemo } from "react";

import * as N from "./nftDetailsElement";
import * as C from "components/common";
import * as D from "components/common/datatable/dataTableElements";
import logo from "assets/logo.svg";
import { useAppDispatch, useAppSelector } from "store/store";
import NftDetailsSidebar from "./nftDetailsSidebar";
import { useLocation, useNavigate } from "react-router-dom";
import { AiOutlineShoppingCart } from "react-icons/all";
import { CommonUtility, ContractUtility } from "utility";
import {
  connectModelSlice,
  mainModel,
} from "store/redux/slices/helperSlices/modelSlice";
import MainModel from "components/modal/mainModel";
import headerimg from "../../assets/headerimg.png";
import { ERC20Service } from "utility/services/erc20";
import {
  NFTTransactionsHook,
  GetSellNftHook,
  CreateTransactionHook,
  ChangeFavouriteHook,
  GetFavouriteHook,
  UpdateSoldStatusHook,
  ConvertPriceHook,
  DeleteSellNftHook,
  switchNetwork,
  AddViewHook,
} from "hooks";
import { AiFillEye } from "react-icons/all";
import { MainNtfDetailDiv, TableDiv, BtnWrapper } from "./nftDetailsElement";
import MainNavbar from "../navbar/mainNavbar";

import detailedit from "../../assets/detailedit.png";
import defaultImage from "../../assets/imgplaceholder.png";
import check from "../../assets/check.png";
import buy from "../../assets/buy.png";
import { AiFillHeart, AiOutlineHeart } from "react-icons/all";
import { Select } from "antd";
import { paymentList } from "components/data/selectData";
import { getUserBalance } from "store/redux/slices/web3/nftMinting/read";
import transaction from "../../assets/transaction.png";
import { FaEdit } from "react-icons/all";
import { Panel } from "rsuite";

type Props = {
  nftDetailsContainer?: boolean;
  nftPriceCard?: boolean;
  buyNowBtn?: boolean;
  makeOfferBtn?: boolean;
  nFtPriceCardPrice?: boolean;
  mainTitle?: boolean;
  collectionDesc?: boolean;
};

const NftDetails: React.FC<Props> = () => {
  const search = useLocation().search;
  const slug = new URLSearchParams(search).get("slug");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [Transactionloading, setLoading] = useState(false);
  const [tokenIcon, setTokenIcon] = useState("");
  const [amount, setAmount] = useState<any>(0);
  const [balance, setBalance] = useState<any>(0);

  const { Option } = Select;

  const { nftFavourite } = useAppSelector((state) => state.favouritesData);
  const { web3, account, chainId, signer, swapSdk, paymentTokens } =
    useAppSelector((state) => state.web3Connect);

  //table

  function createData(
    event: string,
    price: number,
    from: string,
    to: string,
    transactionDate: any
  ) {
    return { event, price, from, to, transactionDate };
  }

  const rows = [
    createData("X Event", 100, "MagicEdenEscrow_1", "A4WkwK", "8 days ago "),
  ];

  //custom hooks
  const {
    detail,
    error,
    loading: detailLoading,
    refetch,
  } = GetSellNftHook(slug);
  const { changeFav, addData, removeData } = ChangeFavouriteHook();
  const { refetch: refetchFav } = GetFavouriteHook(detail);
  const {
    createTransaction,
    loading: transactionLoading,
    error: transactionError,
    data: transactionData,
  } = CreateTransactionHook();
  const { addView } = AddViewHook();
  const {
    updateStatus,
    loading: updateSoldStatusLoading,
    error: updateSoldStatusError,
    data: updateSoldStatusData,
  } = UpdateSoldStatusHook();
  const { getUSD, data: usd } = ConvertPriceHook();
  const { data: transactionsData, fetchData } = NFTTransactionsHook();
  const {
    data: unlistData,
    loading: unlistLoading,
    deleteSellNft,
  } = DeleteSellNftHook();

  //functions
  const handleAmount = async () => {
    let value = detail?.signed_order.erc20TokenAmount;
    const paymentTokens = paymentList(`${detail?.network}`);
    const erc20Token = paymentTokens.find(
      (x) => x.value.toLocaleLowerCase() === detail?.signed_order.erc20Token
    );
    getUSD({ id: erc20Token.cmcId, amount: 1 });
    setTokenIcon(erc20Token.icon?.default);
    setAmount(CommonUtility.handleDivDecimals(value, erc20Token.decimals, 4));
  };

  const unlist = () => {
    try {
      deleteSellNft({
        nft_id: detail?.nft_id,
        network_id: detail?.network,
        transaction_hash: detail.transaction?.transaction_hash,
      });
    } catch (error) {
      console.log(error, "error on unlisting");
    }
  };

  const connectModelFn = () => {
    dispatch(connectModelSlice(true));
  };

  const fillOrder = async () => {
    setLoading(true);
    if (+detail?.signed_order.erc20TokenAmount > +balance) {
      C.ToastMessage(
        "Insufficient Balance",
        "You have indufficient balance to proceed this transaction",
        "warning"
      );
      setLoading(false);
    } else {
      const TAKER_ASSET = {
        tokenAddress: detail?.signed_order.erc20Token, // USDC contract address
        amount: detail?.signed_order.erc20TokenAmount, //  (USDC is 6 digits)
        type: "ERC20",
      };
      const assetsToSwapTaker = [TAKER_ASSET];

      try {
        let nftSwapSdk: any = swapSdk;
        const signedOrder = detail?.signed_order;
        // Approving the taker asset to swapSdk`
        const approvalStatusForUserB = await nftSwapSdk.loadApprovalStatus(
          assetsToSwapTaker[0],
          account
        );

        // If we do need to approve makers assets for swapping, do that
        if (!approvalStatusForUserB.contractApproved) {
          const approvalTx = await nftSwapSdk.approveTokenOrNftByAsset(
            assetsToSwapTaker[0],
            account
          );
          const approvalTxReceipt = await approvalTx.wait();
        }

        // Filling the order (Pass the signed order)
        const fillTx = await nftSwapSdk.fillSignedOrder(
          signedOrder,
          undefined,
          {
            gasLimit: "600000",
          }
        );

        // Wait for the transaction receipt
        const fillTxReceipt = await nftSwapSdk.awaitTransactionHash(
          fillTx.hash
        );

        if (fillTxReceipt.status) {
          setLoading(false);
          createTransaction({
            amount: detail.signed_order.erc20TokenAmount,
            status: "SOLD",
            nft_id: detail.nft_id,
            transaction_hash:
              fillTxReceipt?.transaction_hash || fillTxReceipt?.transactionHash,
            network_id: +detail.network,
          });
          updateStatus(detail.id, detail.nft_id, account);
        } else {
          setLoading(false);
          C.ToastMessage("error", "Transaction Failed", "error");
        }
      } catch (err) {
        setLoading(false);
        console.log("fillTxReceipt", err);
        C.ToastMessage("error", "Something went wrong", "error");
      }
    }
  };

  // use memo
  const switchNet = useMemo(
    () => detail && chainId && chainId != detail?.network,
    [chainId, detail]
  );

  //useEffect
  useEffect(() => {
    if (detail) {
      handleAmount();
    }
  }, [detail]);
  useEffect(() => {
    const getBalance = async () => {
      const paymentTokens = paymentList(`${detail?.network}`);
      const erc20Token = paymentTokens.find(
        (x) => x.value.toLocaleLowerCase() === detail?.signed_order.erc20Token
      );
      const balance = await getUserBalance(web3, erc20Token.value, account);
      setBalance(balance);
    };
    if (detail && web3) {
      addView(detail?.nft_id);
      getBalance();
      fetchData(
        detail?.meta_data?.token_id,
        detail?.meta_data?.asset_contract.address
      );
    }
  }, [detail, web3]);
  useEffect(() => {
    unlistData && navigate("/all-nfts");
  }, [unlistData]);
  useEffect(() => {
    transactionData &&
      updateSoldStatusData &&
      refetch() &&
      C.ToastMessage("Done", "Bought nft Successfully", "success");
  }, [transactionData, updateSoldStatusData]);

  useEffect(() => {
    (addData || removeData) && refetchFav();
  }, [addData, removeData]);

  return (
    <>
      {Transactionloading && <C.Loader content="Buying..." />}
      {detailLoading && <C.Loader content="loading details..." />}
      {unlistLoading && <C.Loader content="unlisting..." />}
      <MainModel />

      <MainNtfDetailDiv>
        <C.MainContainer>
          <div className="d-flex justify-content-end">
            <C.SocialMenu nftId={detail?.nft_id} refetchData={refetch} />
          </div>
          {/* <N.IconContainer>
            <N.IconWrapper>
              <N.Refresh onClick={()=>refetch()} />
              <N.Edit>
                <img className="img-fluid" alt="" src={detailedit} />
              </N.Edit>
              <N.Share />
              <N.Dots />
            </N.IconWrapper>
          </N.IconContainer> */}
          <N.Header>
            <N.TopWrapper>
              <C.MainRow>
                <C.MainCol lg={4}>
                  <N.LeftDiv>
                    <N.ImgContainer>
                      <img
                        className="img-fluid"
                        alt=""
                        src={
                          detail?.nft?.image ||
                          detail?.meta_data.image_preview_url ||
                          defaultImage
                        }
                      />
                    </N.ImgContainer>
                    <N.DescriptionSelectionDiv>
                      <Panel header="Description" collapsible bordered>
                        {detail?.nft?.description ||
                          detail?.meta_data.description ||
                          "No description available"}
                      </Panel>
                    </N.DescriptionSelectionDiv>
                  </N.LeftDiv>
                </C.MainCol>
                <C.MainCol lg={8}>
                  <N.RightDiv>
                    <N.NFTName>
                      {detail?.meta_data.name ||
                        detail?.nft?.name ||
                        detail?.meta_data.asset_contract.name}{" "}
                      <img className="img-fluid" alt="" src={check} />{" "}
                    </N.NFTName>
                    <N.Owner>
                      Owned by{" "}
                      <a>
                        {detail?.user?.name ||
                          CommonUtility.addressConvertor(
                            detail?.wallet_address
                          )}
                      </a>
                      <span>
                        <AiFillEye
                          style={{ marginRight: "5px", marginBottom: "3px" }}
                        />
                        {detail?.views.count} views
                      </span>
                      <span>
                        {nftFavourite.userFavourite ? (
                          <AiFillHeart
                            onClick={() =>
                              web3
                                ? changeFav({ nft_id: detail?.nft_id })
                                : null
                            }
                            style={{
                              marginRight: "5px",
                              marginBottom: "3px",
                              cursor: web3 ? "pointer" : "not-allowed",
                            }}
                          />
                        ) : (
                          <AiOutlineHeart
                            onClick={() =>
                              web3
                                ? changeFav({ nft_id: detail?.nft_id })
                                : null
                            }
                            style={{
                              marginRight: "5px",
                              marginBottom: "3px",
                              cursor: web3 ? "pointer" : "not-allowed",
                            }}
                          />
                        )}
                        {nftFavourite?.favourites?.length} favourites
                      </span>
                    </N.Owner>
                    <N.PriceWrapper>
                      <N.PriceText>
                        Current Price <br />
                      </N.PriceText>
                      <N.Price>
                        <img
                          style={{
                            marginRight: "5px",
                            marginBottom: "3px",
                            fontSize: "25px",
                            color: "#333333",
                            width: "20px",
                          }}
                          src={tokenIcon}
                        />
                        {amount ? amount : "0"}{" "}
                        <small>(${(usd * amount).toFixed(4)})</small>
                      </N.Price>
                    </N.PriceWrapper>
                    <BtnWrapper>
                      {web3 ? (
                        <C.Buttons
                          disabled={
                            detail?.transaction.status === "SOLD" ||
                            Transactionloading ||
                            unlistLoading
                          }
                          onClick={() =>
                            account.toLocaleLowerCase() ===
                            detail?.wallet_address
                              ? unlist()
                              : switchNet
                              ? switchNetwork(web3, detail?.network)
                              : fillOrder()
                          }
                          buyBtn
                        >
                          <img className="img-fluid" alt="" src={buy} />
                          {account.toLocaleLowerCase() ===
                          detail?.wallet_address
                            ? "Unlist"
                            : switchNet
                            ? " Switch Network"
                            : detail?.transaction.status === "SOLD"
                            ? "Sold Out!"
                            : "Buy"}
                        </C.Buttons>
                      ) : (
                        <C.MainButton connectModel onClick={connectModelFn}>
                          Connect Wallet
                        </C.MainButton>
                      )}
                      {switchNet && (
                        <p>
                          In order to buy nft kindly switch to
                          {ContractUtility.getNetwork(detail?.network)}
                        </p>
                      )}
                    </BtnWrapper>
                    <C.MainRow>
                      <C.MainCol>
                        <N.TransactionHistoryDiv>
                          <Panel
                            header={
                              <N.CollapseHeader>
                                <img
                                  src={transaction}
                                  alt=""
                                  style={{ transform: "translateY(5px)" }}
                                />
                                <N.CollapseHeaderTitle>
                                  Transaction History
                                </N.CollapseHeaderTitle>
                              </N.CollapseHeader>
                            }
                            collapsible
                            bordered
                          >
                            <N.TopTransactionDiv>
                              <div className="transactionHeader">
                                <div>Event</div>
                                <div>Price</div>
                                <div>From</div>
                                <div>To</div>
                                <div>Tx Hash</div>
                                <div>Date</div>
                              </div>
                              <N.RowDivider />
                              <div className="transactionBody">
                                {transactionsData &&
                                  transactionsData.map((data, i) => {
                                    return (
                                      <div
                                        key={`tran-${i}`}
                                        className="transactionItem"
                                      >
                                        <div className="transactionBodyItem">
                                          {" "}
                                          <AiOutlineShoppingCart
                                            style={{
                                              marginRight: "5px",
                                              marginBottom: "3px",
                                            }}
                                          />
                                          {data.event}
                                        </div>

                                        <div className="price transactionBodyItem">
                                          {data.amount}
                                        </div>
                                        <div className="transactionBodyItem">
                                          <a href="#">
                                            {CommonUtility.addressConvertor(
                                              data.from
                                            )}
                                          </a>
                                        </div>
                                        <div className="transactionBodyItem">
                                          <a href="#">
                                            {CommonUtility.addressConvertor(
                                              data.to
                                            )}
                                          </a>
                                        </div>
                                        <div className="transactionBodyItem">
                                          <a
                                            target="_blank"
                                            href={`${ContractUtility.getNetworkExplorer(
                                              (detail?.network).toString()
                                            )}/tx/${data.transactionHash}`}
                                          >
                                            {CommonUtility.addressConvertor(
                                              data.transactionHash
                                            )}
                                          </a>{" "}
                                        </div>
                                        <div className="transactionBodyItem">
                                          {CommonUtility.mm_dd_yy(
                                            data?.transactionDate
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </N.TopTransactionDiv>
                          </Panel>
                        </N.TransactionHistoryDiv>
                      </C.MainCol>
                    </C.MainRow>
                  </N.RightDiv>
                </C.MainCol>
              </C.MainRow>
            </N.TopWrapper>
          </N.Header>
        </C.MainContainer>
      </MainNtfDetailDiv>
    </>
  );
};

export default NftDetails;
